<template>
  <el-card class="data" v-loading="loading">
    <div class="data-title flex-space-between" slot="header">
      <p>Talent Scout Territories</p>
      <el-date-picker
        v-model="date_range"
        class="float-right"
        type="daterange"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="filter()"
      ></el-date-picker>
    </div>
    <el-table
      :data="territories.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column
        label="Country"
        prop="country"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        label="Downloads"
        prop="downloads"
        sortable="custom"
      ></el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="territories.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="territories.total"
    ></el-pagination>
  </el-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      date_range: ''
    }
  },

  computed: {
    ...mapState('newReleasesReports', [
      'territories',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading'
    ])
  },

  methods: {
    ...mapActions('newReleasesReports', ['readTerritories']),
    ...mapMutations('newReleasesReports', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialog'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readTerritories()
    },
    currentChange(page) {
      this.setPage(page)
      this.readTerritories()
    },
    filter() {
      let filter_data = {
        date_start: this.date_range[0],
        date_end: this.date_range[1]
      }
      localStorage.setItem('territories_filter', JSON.stringify(filter_data))
      this.readTerritories()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readTerritories()
    }
  },

  created() {
    this.readTerritories()
  }
}
</script>
